export default "__VITE_ASSET__BY$L1g2v__"